
import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';

export default function About() {
  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero 섹션 */}
      <section className="relative pt-24 pb-20 bg-stone-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-4xl mx-auto">
            <div className="inline-block px-4 py-2 bg-orange-100 text-orange-700 text-sm font-medium rounded-full mb-6">
              ABOUT QUANTUMHI
            </div>
            <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6 leading-tight">
              한국과 일본을 연결하는<br />
              신뢰할 수 있는 파트너
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed">
              퀀텀하이는 한국과 일본 간의 무역, 교육, 콘텐츠 분야에서<br />
              혁신적이고 지속 가능한 비즈니스 솔루션을 제공합니다
            </p>
          </div>
        </div>
      </section>

      {/* 회사 소개 */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div className="space-y-8">
              <h2 className="text-4xl font-bold text-gray-900">
                우리의 비전
              </h2>
              <div className="space-y-6 text-gray-600 text-lg leading-relaxed">
                <p>
                  주식회사 퀀텀하이는 한국과 일본 간의 문화적, 경제적 교류를 촉진하며 
                  양국 간의 지속 가능한 파트너십을 구축하는 것을 목표로 합니다.
                </p>
                <p>
                  제조업체와의 직접 거래를 통한 투명한 무역, 실용적인 언어 교육 서비스, 
                  그리고 글로벌 브랜드를 위한 콘텐츠 제작까지 - 우리는 다양한 분야에서 
                  혁신적인 솔루션을 제공합니다.
                </p>
                <p>
                  모든 프로젝트에서 품질과 신뢰성을 최우선으로 하며, 
                  고객과의 장기적인 관계 구축을 통해 함께 성장해 나가고 있습니다.
                </p>
              </div>
            </div>
            <div 
              className="h-96 bg-cover bg-center rounded-2xl"
              style={{
                backgroundImage: `url('https://public.readdy.ai/ai/img_res/1c465ae2bd26f3626f2984622e394f2d.jpg')`
              }}
            ></div>
          </div>
        </div>
      </section>

      {/* 핵심 가치 */}
      <section className="py-20 bg-stone-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              퀀텀하이의 핵심 가치
            </h2>
            <p className="text-xl text-gray-600">
              우리가 추구하는 가치와 원칙들입니다
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-2xl text-center">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-handshake-line text-2xl text-orange-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">신뢰</h3>
              <p className="text-gray-600 leading-relaxed">
                투명한 커뮤니케이션과 약속 이행을 통해 고객과의 신뢰 관계를 구축합니다
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl text-center">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-star-line text-2xl text-orange-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">품질</h3>
              <p className="text-gray-600 leading-relaxed">
                제품과 서비스의 품질을 최우선으로 하여 고객 만족을 실현합니다
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl text-center">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-global-line text-2xl text-orange-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">혁신</h3>
              <p className="text-gray-600 leading-relaxed">
                지속적인 혁신을 통해 변화하는 시장에 유연하게 대응합니다
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
